let mutations = {
  loginError (state, data) {
    state.loginError = data.error
  },
  otpError (state, data) {
    state.otpError = data.error
  },
  setSessionID (state, data) {
    state.sessionId = data.session_id
  },
  setUser (state, data) {
    localStorage.setItem('version', data.version)
    state.user = data
    state.loggedIn = true
    state.userType = data.icici_customer
  },
  unsetUser (state, data) {
    state.user = undefined
    state.loggedIn = false
    state.userType = false
  },
  setMobile (state, data) {
    state.mobile = data
  },
  setLoginState (state, data) {
    localStorage.setItem("loggedIn", data)
    state.loggedIn = data
  }

}
export default mutations



// WEBPACK FOOTER //
// ./src/store/login/mutations.js